import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useLanguage } from "context/LanguageContext";

function PdfExportDialog({
  open,
  onClose,
  onConfirm,
  documentType,
  setDocumentType,
  unitPriceInput,
  setUnitPriceInput,
}) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("selectPdfType")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("selectPdfTypeDescription")}</DialogContentText>
        <RadioGroup value={documentType} onChange={(e) => setDocumentType(e.target.value)}>
          <FormControlLabel value="purchase" control={<Radio />} label={t("purchaseInvoices")} />
          <FormControlLabel value="sales" control={<Radio />} label={t("salesInvoices")} />
        </RadioGroup>

        <MDBox mt={3}>
          <TextField
            fullWidth
            label={t("unitPrice")}
            type="number"
            value={unitPriceInput}
            onChange={(e) => setUnitPriceInput(e.target.value)}
            helperText={t("unitPriceOptional")}
            InputProps={{
              inputProps: {
                min: 0,
                step: 0.01,
              },
            }}
          />
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="secondary">
          {t("cancel")}
        </MDButton>
        <MDButton onClick={onConfirm} color="primary">
          {t("generate")}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

PdfExportDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  setDocumentType: PropTypes.func.isRequired,
  unitPriceInput: PropTypes.string.isRequired,
  setUnitPriceInput: PropTypes.func.isRequired,
};

export default PdfExportDialog;
